import React from 'react';
import ReactDOM from 'react-dom/client';
import './initTheme'; // Inicializar colores ANTES de importar componentes
import './index.scss';
import AppRoutes from './routes/Routes.tsx';
import { SignersProvider } from './context/SignersContext.tsx';
import { ThemeProvider } from './context/ThemeContext.tsx';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider>
      <SignersProvider>
        <AppRoutes />
      </SignersProvider>
    </ThemeProvider>
  </React.StrictMode>
);
